export default "__VITE_ASSET__CjiuT60o__"